import { Controller } from "stimulus";
import { M } from "@materializecss/materialize/dist/js/materialize";

export default class extends Controller {
  static get targets() {
    return ["field"];
  }

  connect() {
    M.Datepicker.init(this.fieldTarget, this.options);
  }

  get options() {
    return {
      minDate: new Date(this.fieldTarget.dataset.minDate),
      maxDate: new Date(this.fieldTarget.dataset.maxDate),
      defaultDate: new Date(this.fieldTarget.dataset.defaultDate),
      setDefaultDate: true,
      showClearBtn: true,
    };
  }
}
